import Image from 'global/Image';
import { Common } from '@stockbit/ui';

const { Flex, Text } = Common;

const EmptyNotes = () => (
  <Flex
    align="center"
    justify="center"
    style={{ height: 500 }}
    direction="column"
  >
    <Image src="/icon/notes/notes-empty.svg" />
    <Text
      size="13px"
      weight="bold"
      mt="16px"
    >
      No Notes Available
    </Text>
    <Text size="13px" mt="4px">
      Add a new note from a company page
    </Text>
  </Flex>
);

export default EmptyNotes;
